<template>
    <div class="flex justify-center items-center relative">
        <div>
            <svg :viewBox="viewBox" class="progress" xmlns="http://www.w3.org/2000/svg">
                <circle class="circle-background"></circle>
                <circle class="circle-progress"></circle>
            </svg>
        </div>
        
        <span :class="[`absolute progress-value font-medium`, progressClass]">
            {{ progress }}
        </span>
    </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'

const PROGRESS_COLORS = {
    green: "#2A8176",
    yellow: "#F3894F",
    red: "#EB5757"
}

const props = defineProps({
    progress: {
        type: Number,
        default: 0,
    },
    circleWidth: {
        type: Number,
        default: 50
    },
    strokeWidth: {
        type: Number,
        default: 4
    },
    progressClass: {
        type: String,
        default: ""
    },
    rotate: {
        type: Number,
        default: 270
    }
})

const { circleWidth, strokeWidth, progressClass, rotate, progress } = toRefs(props)

const radius = computed(() => circleWidth.value / 2 - strokeWidth.value)
const strokeDashArray = computed(() => 2 * Math.PI * radius.value)
const viewBox = computed(() => `0 0 ${circleWidth.value} ${circleWidth.value}`)
const strokeDashOffset = computed(() => strokeDashArray.value * ((100 - progress.value) / 100))
const rotateBy = computed(() => `${rotate.value}deg`)
const strokeWidthValue = computed(() => `${strokeWidth.value}px`)
const circleWidthValue = computed(() => `${circleWidth.value}px`)

const progressColor = computed(() => {
    if (progress.value < 50) {
        return PROGRESS_COLORS.red
    } else if (progress.value < 75) {
        return PROGRESS_COLORS.yellow
    }

    return PROGRESS_COLORS.green
})
</script>

<style scoped>
.progress {
    width: v-bind(circleWidthValue);
    height: v-bind(circleWidthValue);
    transform: rotate(v-bind(rotateBy));
}

.circle-background,
.circle-progress {
    r: v-bind(radius);
    cx: 50%;
    cy: 50%;
    fill: none;
    stroke-width: v-bind(strokeWidthValue);
}

.circle-background {
    stroke: #EEF2FE;
}

.circle-progress {
    stroke: v-bind(progressColor);
    stroke-dasharray: v-bind(strokeDashArray);
    stroke-dashoffset: v-bind(strokeDashOffset);
    stroke-linecap: round;
}

.progress-value {
    color: v-bind(progressColor);
}
</style>